module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/lang/fr-FR.json
// module id = 292
// module chunks = 0